import { Container, View } from "dripsy";
import * as React from "react";
import { Platform } from "react-native";

import BackButton from "./back-button";
import { useSafeArea } from "../provider/safe-area/use-safe-area";

export default function AbsoluteBackButton({ onPress }: { onPress?: () => void }) {
  const insets = useSafeArea();
  const pointerEventsProps = Platform.OS !== "web" ? { pointerEvents: "box-none" as const } : {};

  return (
    <Container
      {...pointerEventsProps}
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        zIndex: 100,
        ...(Platform.OS === "web" ? { pointerEvents: "box-none" } : {}),
      }}
    >
      <View
        sx={{
          position: "absolute",
          left: Platform.select({ default: 12 + insets.right, web: 12 }),
          top: Platform.select({ default: 3 + insets.top, web: 3 }),
          zIndex: 100,
        }}
      >
        <BackButton onPress={onPress} />
      </View>
    </Container>
  );
}
